import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { GeneralName } from "@peculiar/asn1-x509";
import { Version } from "./version";
export const id_adbe_timestamp = "1.2.840.113583.1.1.9.1";
export class Timestamp {
    constructor(params = {}) {
        this.version = Version.v1;
        this.location = new GeneralName();
        this.requiresAuth = false;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], Timestamp.prototype, "version", void 0);
__decorate([
    AsnProp({ type: GeneralName })
], Timestamp.prototype, "location", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Boolean, defaultValue: false, optional: true })
], Timestamp.prototype, "requiresAuth", void 0);
